module.exports = __webpack_public_path__ + "static/media/Shop_Gold_TriangleDivider@3x.cb4c0a3a.png";